import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { ContextService } from '../context.service';
import { filter, map, take } from 'rxjs';
import { ErrorService } from '../errors/error.service';
import { ResourceType } from '../errors/error.model';

export const OrganizationGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const contextService = inject(ContextService);
  const errorService = inject(ErrorService);

  const orgName = route.params['organizationName'];

  // If user already belongs to this organization, allow access
  if (contextService.belongsToOrganization(orgName)) {
    return true;
  }

  // Wait for organization to load from token, then validate
  return contextService.organization$.pipe(
    filter(org => org !== null),
    take(1),
    map(organization => {
      if (contextService.belongsToOrganization(orgName)) {
        return true;
      }

      // URL org doesn't match user's org - redirect to not-found error page
      console.warn(`Organization "${orgName}" not found for user`);
      errorService.notFound(ResourceType.ORGANIZATION);
      return false;
    })
  );
};
